import Aos from "aos";
import "aos/dist/aos";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Newsletter.css";
const Newsletter = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="newsletter overflow-hidden">
      <Container>
        <Row
          data-aos="fade-left"
          className="align-items-center newsletter-main"
        >
          <Col md={6} sm={12} xs={12}>
            <div className="newsletter-title">
              <h3>Join Our</h3>
              <h3>Newsletter Now</h3>
            </div>
          </Col>
          <Col md={6} sm={12} xs={12}>
            <div className="submit-newsletter">
              <input
                type="email"
                name=""
                placeholder="Your email address"
                id=""
              />
              <button>Subscribe</button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Newsletter;
